/*
 * If you add a locale here, you must also:
 * - add it to the lyaml file
 * - add its native name (endonym) to LOCALE_LABELS below
 * - check the locales are supported by Google Recaptcha (We change the recaptcha locale
 *   when lang select changes): https://developers.google.com/recaptcha/docs/language?hl=en
 */
export const LOCALES = ['af', 'ar-eg', 'bg', 'bn', 'ca-es', 'cs', 'da', 'de', 'el', 'en', 'en-gb', 'es', 'es-mx', 'et', 'fi', 'fr', 'fr-ca', 'he-il', 'hi', 'hr', 'hu', 'id', 'it', 'ja', 'ko', 'lt', 'ms', 'nl', 'no', 'pl', 'pt-br', 'pt-pt', 'ro', 'ru', 'sk', 'sl', 'sv', 'th', 'tl', 'tr', 'uk', 'vi', 'zh-cn', 'zh-hk', 'zh-tw'];
/*
 * The language select shows every language in its own language (its endonym),
 * regardless of the locale the page is rendered in. Only the active locale's
 * translations are loaded at runtime, so these labels can't be read from the
 * i18n store — they're kept here as static strings sourced from each locale's
 * own `app.language.options.<self>` translation.
 */
export const LOCALE_LABELS = {
  af: 'Afrikaans',
  'ar-eg': 'العربية (مصر)',
  bg: 'Български',
  bn: 'বাংলা',
  'ca-es': 'Català (Espanya)',
  cs: 'Čeština',
  da: 'Dansk',
  de: 'Deutsch',
  el: 'Ελληνικά',
  en: 'English',
  'en-gb': 'English (United Kingdom)',
  es: 'Español',
  'es-mx': 'Español (México)',
  et: 'Eesti keel',
  fi: 'Suomi',
  fr: 'Français',
  'fr-ca': 'Français (Canada)',
  'he-il': 'עברית (ישראל)',
  hi: 'हिन्दी',
  hr: 'Hrvatski',
  hu: 'Magyar',
  id: 'Bahasa Indonesia',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  lt: 'Lietuvių',
  ms: 'Bahasa Melayu',
  nl: 'Nederlands',
  no: 'Norsk',
  pl: 'Polski',
  'pt-br': 'Português (Brasil)',
  'pt-pt': 'Português (Portugal)',
  ro: 'Română',
  ru: 'Русский',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  sv: 'Svenska',
  th: 'ไทย',
  tl: 'Tagalog',
  tr: 'Türkçe',
  uk: 'Українська',
  vi: 'Tiếng Việt',
  'zh-cn': '中文（中国）',
  'zh-hk': '中文 (香港)',
  'zh-tw': '中文 (台灣)'
};